const jsonData = `{
    "width": 1600,
    "height": 2400,
    "elevation": 0.5,
    "thrower": {
        "type": "sphere",
        "material": "cc0000",
        "size": { "r": 0.2 },
        "start_position": {
            "x": 0,
            "y": 2.4,
            "z": 0
        },
        "force_multiplier": 0.2,
        "throw_path": [
            {  
                "curve":
                    [
                        [0,0],
                        [60,45],
                        [90,60],
                        [100,0]
                    ],
                "weight":8
            }
        ]
    },
    "score_proximity": 4,
    "targets": [
        {
            "hits": 1,
            "position": {
                "x": 7,
                "y": 10,
                "z": -40,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": -7,
                "y": 10,
                "z": -40,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": 0,
                "y": 12,
                "z": -47,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": 0,
                "y": 20,
                "z": -40,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": 14,
                "y": 17,
                "z": -40,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": -14,
                "y": 17,
                "z": -40,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": 7,
                "y": 30,
                "z": -49,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": -7,
                "y": 30,
                "z": -49,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": 20,
                "y": 13,
                "z": -47,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": -20,
                "y": 13,
                "z": -47,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": 0,
                "y": 50,
                "z": -40,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        },
        {
            "hits": 1,
            "position": {
                "x": 0,
                "y": 50,
                "z": -40,
                "duration": 0
            },
            "object": {
                "type": "cylinder",
                "material": {
                    "color": "ff00ff"
                },
                "size": {
                    "r": 0,
                    "y": 0
                },
                "rotation": {
                    "x": 90,
                    "y": 0,
                    "z": 0
                }
            }
        }
    ],
    "barriers": [
    ],
    "throw_duration": 1,
    "camera_position": {
        "x": 0,
        "y": 5,
        "z": 12
    },
    "lights": [
        {
            "color": "ffffff",
            "intensity": 2,
            "target": {
                "x": 1,
                "y": -8,
                "z": -3
            }
        },
        {
            "color": "ffffff",
            "intensity": 0.7,
            "target": {
                "x": 0,
                "y": 8,
                "z": -2
            }
        }   
    ],
    "objects": [
    ]
}`;

const gameData = JSON.parse(jsonData);

const exampleMove = JSON.parse('[{"x":201,"y":442},{"x":201,"y":444},{"x":199,"y":449},{"x":197,"y":459},{"x":196,"y":469},{"x":196,"y":477},{"x":196,"y":483},{"x":196,"y":488},{"x":196,"y":491},{"x":196,"y":494},{"x":196,"y":497},{"x":196,"y":499},{"x":196,"y":501},{"x":196,"y":502},{"x":196,"y":504},{"x":195,"y":506},{"x":195,"y":510},{"x":194,"y":514},{"x":193,"y":518},{"x":193,"y":523},{"x":192,"y":526},{"x":191,"y":530},{"x":190,"y":535},{"x":189,"y":538},{"x":188,"y":541},{"x":188,"y":543},{"x":188,"y":544},{"x":188,"y":545},{"x":187,"y":546},{"x":187,"y":548},{"x":186,"y":549},{"x":185,"y":551},{"x":185,"y":552},{"x":185,"y":552},{"x":184,"y":553},{"x":184,"y":553},{"x":184,"y":553},{"x":185,"y":553},{"x":185,"y":554},{"x":187,"y":554},{"x":190,"y":555},{"x":192,"y":556},{"x":195,"y":556},{"x":198,"y":556},{"x":201,"y":556},{"x":204,"y":556},{"x":207,"y":556},{"x":211,"y":556},{"x":216,"y":555},{"x":221,"y":555},{"x":227,"y":555},{"x":232,"y":555},{"x":238,"y":555},{"x":244,"y":555},{"x":250,"y":554},{"x":254,"y":554},{"x":260,"y":553},{"x":266,"y":553},{"x":273,"y":552},{"x":280,"y":552},{"x":286,"y":552},{"x":291,"y":552},{"x":294,"y":552},{"x":296,"y":552},{"x":297,"y":552},{"x":297,"y":552},{"x":298,"y":552},{"x":299,"y":552},{"x":300,"y":552},{"x":301,"y":552},{"x":301,"y":552},{"x":300,"y":552},{"x":298,"y":552},{"x":295,"y":552},{"x":290,"y":552},{"x":283,"y":552},{"x":275,"y":553},{"x":267,"y":554},{"x":258,"y":555},{"x":249,"y":555},{"x":240,"y":556},{"x":233,"y":557},{"x":227,"y":558},{"x":223,"y":559},{"x":219,"y":560},{"x":216,"y":560},{"x":211,"y":562},{"x":207,"y":563},{"x":203,"y":564},{"x":198,"y":565},{"x":194,"y":565},{"x":190,"y":566},{"x":187,"y":566},{"x":184,"y":566},{"x":182,"y":566},{"x":180,"y":566},{"x":178,"y":566},{"x":176,"y":567},{"x":174,"y":567},{"x":172,"y":568},{"x":171,"y":568},{"x":170,"y":569},{"x":169,"y":569},{"x":167,"y":570},{"x":164,"y":571},{"x":162,"y":571},{"x":159,"y":571},{"x":156,"y":571},{"x":153,"y":571},{"x":151,"y":571},{"x":149,"y":571},{"x":148,"y":571},{"x":147,"y":571},{"x":147,"y":571},{"x":147,"y":571},{"x":146,"y":570},{"x":146,"y":570},{"x":145,"y":570},{"x":145,"y":570},{"x":144,"y":569},{"x":144,"y":569},{"x":144,"y":569},{"x":144,"y":569},{"x":144,"y":568},{"x":144,"y":567}]');

export { exampleMove };
export default gameData;
